
export const PageTitle = ({ children }) => {

    return (
        <h1 className="py-2 text-uni">{children}</h1>
    );
}
